exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointSiteCard_3D8VCD3zauVEWY0bcaX6G-{\n  display:flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.IA_sharePointSiteWrapper_1hEytj6Gq7xV6OzOr-RouQ {\n  font-size: 14px;\n  float: left;\n  display: block;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.IA_sharePointSiteId_1QyKojG2mA5JjbTntDqUy1 {\n  font-size: 9px;\n  opacity: 0.8\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointSiteCard": "IA_sharePointSiteCard_3D8VCD3zauVEWY0bcaX6G-",
	"IA_sharePointSiteWrapper": "IA_sharePointSiteWrapper_1hEytj6Gq7xV6OzOr-RouQ",
	"IA_sharePointSiteId": "IA_sharePointSiteId_1QyKojG2mA5JjbTntDqUy1"
};